import RowResumeText from '../../../../components/RowResumeText';
import { EMPTY_VALUES, getDateFormat } from '../../../../Apis/functions';
import { gender } from '../../../../enums/genderEnum';
import { useTranslation } from 'react-i18next';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 * @param user
 */
const SummaryFieldsUser = ({ user }) => {

    const { t } = useTranslation();

    return (
        <>
            <div className="col-12 col-sm-6 pb-2">
                <RowResumeText title={t('name')} value={user?.name || EMPTY_VALUES.DEFAULT} />
            </div>
            <div className="col-12 col-sm-6 pb-2">
                <RowResumeText title={t('last_name')} value={user?.lastName || EMPTY_VALUES.DEFAULT} />
            </div>
            <div className="col-12 col-sm-6 pb-2">
                <RowResumeText title={t('document_id')} value={user?.documentId || EMPTY_VALUES.DEFAULT} />
            </div>
            <div className="col-12 col-sm-6 pb-2">
                <RowResumeText title={t('email')} value={user?.email || EMPTY_VALUES.DEFAULT} />
            </div>
            <div className="col-12 col-sm-6 pb-2">
                <RowResumeText title={t('phone_number')} value={user?.phoneNumber || EMPTY_VALUES.DEFAULT} />
            </div>
            <div className="col-12 col-sm-6 pb-2">
                <RowResumeText title={t('gender')} value={t(gender[user?.genderId]) || EMPTY_VALUES.DEFAULT} />
            </div>
            <div className="col-12 col-sm-6 pb-2">
                <RowResumeText title={t('dob')} value={getDateFormat(user?.dob, false)} />
            </div>
        </>
    );
}

export default SummaryFieldsUser
